<template>
  <div>
    <base-material-table
      outlined
      :item="item"
      :excel='excel'
      ref="table"
      show-select
      mobile-show-select
      v-model="selected"
    >
      <template v-slot:condition>
        <v-col cols="12" md='2' class="pl-0">
          <base-marerial-user-select @on-change="loadData" label='用户选择(负责人)' hide-details outlined dense v-model="item.params.userIds" mid :menu='$constants.SysMenu.PARTENT_LIST_M_ID'></base-marerial-user-select>
        </v-col>
      </template>
       <template v-slot:actions>
        <v-btn depressed dark :small='$isMobile' color="cyan" v-has="'patent-pay-apply'" @click="batchApply" class="mx-1 px-2">
          <v-icon size="20" dark>mdi-file-check-outline</v-icon>费用申请
        </v-btn>
      </template>
    </base-material-table>
    <base-material-simple-alert
      :show.sync='acceptModal.show'
      title='缴费提示'
      @on-submit='pay'
      >
      <template v-slot:content>
        <v-row>
          <v-col>
            <file-upload
              label="收据上传(命名：专利号_受理费收据.pdf)"
              filled rounded  dense
              small-chips
              multiple
              prepend-icon=''
              accept=".pdf"
              :bucket='bucket'
              @on-files='onFileName'
            />
          </v-col>
        </v-row>
      </template>
    </base-material-simple-alert>
    <v-snackbar v-model="tip.show" timeout='3000' centered rounded="pill" color="warning">
      <span :class="$isMobile ? 'size-13' : 'size-20'">!&nbsp;{{ tip.text }}</span>
      <template v-slot:action="{ attrs }">
        <v-btn text fab v-bind="attrs" small @click="tip.show = false"><v-icon>mdi-close</v-icon></v-btn>
      </template>
    </v-snackbar>
    <pay-apply :item='payApplyModal' @on-load-data='loadData'></pay-apply>
  </div>
</template>

<script>
  import FileUpload from '@/components/oss/Index.vue'
  import { edit } from '@/api/patent/index.js'
  import { hasten } from '@/api/patent/cost.js'
  import { getNextMonth } from '@/utils/tool.js'
  import { isEmpty } from '@/utils/stringUtil.js'
  import PayApply from './PayApply.vue'

  export default {
    name: 'PatentAcceptCost',
    components: {
      PayApply,
      FileUpload
    },
    data() {
      return {
        bucket: 'yd-patent',
        selected: [],
        acceptCostFileName: '',
        tip: { show: false, text: '' },
        detailModal: { show: false, data: {} },
        acceptModal: { show: false, data: {} },
        payApplyModal: { show: false, data: {} },
        item: {
          mobile: true,
          path: 'patent/info/list',
          topButtons: [
            { event: 'search', show: true },
            { event: 'download', show: this.$_has('patent-info-down') }
          ],
          params: {
            status: [25],
            listType: 3,
            acceptFeeStatus: 0,
            acceptTimeType: ''
          },
          sort: {
            orderByField: 'accept_time ',
            asc: true
          },
          headers: [
            {
              text: '企业名称',
              align: 'center',
              divider: true,
              value: 'customerName',
              sortable: false,
              copy: true,
              width: 200,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
            {
              text: '专利名称',
              align: 'center',
              divider: true,
              value: 'name',
              sortable: false,
              copy: true,
              width: 200,
              mobile: true,
              search: { type: 'input', mobile: true }
            },
             {
              text: '专利编号',
              align: 'center',
              divider: true,
              value: 'patentCode',
              sortable: false,
              width: 170,
              copy: true,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '受理时间',
              align: 'center',
              value: 'acceptTime',
              sortable: true,
              width: 150,
              divider: true,
              mobile: true,
              formatter: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            {
              text: '受理费',
              align: 'center',
              divider: true,
              value: 'acceptFee',
              sortable: false,
              mobile: true,
              width: 100,
            },
            {
              text: '缴费截止时间',
              align: 'center',
              value: 'acceptEndTime',
              divider: true,
              sortable: true,
              width: 150,
              mobile: true,
              formatter: (val) => (isEmpty(val) ? '--' : this.$moment(val * 1000).format('YYYY-MM-DD'))
            },
            {
              text: '是否申请',
              align: 'center',
              divider: true,
              value: 'acceptFeeApplyPayStatus',
              sortable: false,
              width: 100,
              mobile: true,
              span: {
                color: (val) => (val === 0 ? '' : 'green'),
                formatter: (val) => (val === 0 ? '未申请' : '已申请')
              }
            },
            {
              text: '专利类型',
              align: 'center',
              divider: true,
              value: 'patentType',
              sortable: false,
              width: 120,
              mobile: true,
              search: {
                type: 'select',
                name: 'patentType',
                options: () => [
                  { label: '实用新型', value: 1 },
                  { label: '发明专利', value: 2 },
                  { label: '外观专利', value: 3 }
                ]
              },
              chip: {
                color: (val) => (val === 1 ? 'success' : val === 2 ? 'cyan' : 'blue'),
                formatter: (val) => (val === 1 ? '实用新型' : val === 2 ? '发明专利' : '外观专利')
              }
            },
            {
              text: '业务负责人',
              align: 'center',
              divider: true,
              value: 'signUser',
              sortable: false,
              mobile: true,
              width: 140,
              formatter: (val, item) => {
                let name = ''
                if (item.contract) {
                  item.contract.contactsPersonList.forEach(i => {
                    name += `${i.name}|`
                  })
                }
                return (val ? val.name : name.substring(0, name.lastIndexOf("|"))) || '--'
              }
            },
            {
              text: '状态',
              align: 'center',
              value: 'acceptFeeStatus',
              divider: true,
              sortable: false,
              width: 100,
              formatter: (val) => (val === 0 ? '未缴纳' : val === 1 ? '已缴纳' : '未知')
            },
            {
              text: '申请人名称',
              align: 'center',
              divider: true,
              value: 'applyUser',
              sortable: false,
              width: 200,
              copy: true,
              mobile: true,
              formatter: (val) => val || '--',
              search: { type: 'input', mobile: true }
            },
            {
              text: '合同编号',
              align: 'center',
              value: 'contract',
              sortable: false,
              copy: true,
              mobile: true,
              width: 200,
              formatter: (val) => (val ? val.serialNumber : '--'),
            },
            // {
            //   text: '缴费截止',
            //   align: 'center',
            //   divider: true,
            //   value: 'acceptTime',
            //   sortable: false,
            //   width: 120,
            //   chip: {
            //     color: (val) => {
            //       const day = this.day(val)
            //       return day > 30 ? 'success' : (day <= 30 && day > 7) ? 'secondary' : 'error'
            //     },
            //     formatter: (val) => (this.day(val) < 0 ? `超时(${Math.abs(this.day(val))}天)` : `${this.day(val)}天后`)
            //   }
            // },
            {
              text: '操作',
              value: 'actions',
              align: 'center',
              sortable: false,
              width: 120,
              class: 'fixed-right',
              cellClass: 'fixed-right',
              mobile: true,
              menu: {
                text: '操作',
                color: 'primary',
                icon: 'mdi-menu-down-outline',
                actions: [
                  {
                    text: '缴费',
                    color: 'blue',
                    icon: 'mdi-pencil',
                    onClick: (row) => {
                      this.acceptModal = { show: true, data: row }
                    },
                    disable: (row) => !this.$_has('patent-cost-edit') || row.acceptFeeStatus === 1
                  },
                  {
                    text: '费用申请',
                    color: 'green',
                    icon: 'mdi-file-check-outline',
                    onClick: (row) => {
                      if (!row.contract) {
                        this.tip = { show: true, text: '操作失败【未关联合同,请联系管理员】' }
                        return
                      }
                      this.payApplyModal = { show: true, data: [row], type: 1 }
                    },
                    disable: (row) => !this.$_has('patent-pay-apply') || row.acceptFeeApplyPayStatus === 1
                  },
                  // {
                  //   text: '催缴',
                  //   color: 'warning',
                  //   icon: 'mdi-pencil',
                  //   onClick: (row) => this.hasten(row.id),
                  //   disable: () => !this.$_has('patent-cost-hasten')
                  // }
                ]
              }
            }
          ]
        },
        excel: {
          path: 'patent/info/down',
          filename: '专利受理费待缴名单.xls',
          header: '专利申请名单',
          fields: {
            客户名称: 'customerName',
            专利名称: 'name',
            专利类型: {
              field: 'patentType',
              callback: (val) => (val === 1 || val === 3 ? '实用新型/外观' : '发明')
            },
            业务负责人: 'busPersion',
            专利号: 'patentCode',
            受理时间: {
              field: 'acceptTime',
              callback: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            },
            受理费: 'acceptFee',
            截止时间: {
              field: 'acceptEndTime',
              callback: (val) => this.$moment(val * 1000).format('YYYY-MM-DD')
            }
          }
        }
      }
    },
    methods: {
      batchApply () {
        if (this.selected.length < 2) {
          this.tip = { show: true, text: '操作失败【至少选择两个专利】' }
          return
        }
        if (!this.selected[0].contract) {
          this.tip = { show: true, text: '操作失败【未关联合同,请联系管理员】' }
          return
        }
        const { serialNumber } = this.selected[0].contract
        for (let i = 0; i < this.selected.length; i++) {
          if (!this.selected[i].contract) {
            this.tip = { show: true, text: '操作失败【未关联合同,请联系管理员】' }
            return
          }
          if (this.selected[i].acceptFeeApplyPayStatus === 1) {
            this.tip = { show: true, text: '操作失败【重复申请,包含已申请数据】' }
            return
          }
          if (serialNumber !== this.selected[i].contract.serialNumber) {
            this.tip = { show: true, text: '操作失败【请选择相同合同申请】' }
            return
          }
        }
        this.payApplyModal = { show: true, data: this.selected, type: 1 }
      },
      pay () {
        this.acceptModal.data.acceptFeeStatus = 1
        edit(this.acceptModal.data).then(res => {
          if (res.status === 200) {
            this.acceptModal.show = false
            this.loadData()
            this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
          }
        })
      },
      onFileName (fileNames) {
        let acceptCostFileName = ''
        fileNames.forEach(name => {
          acceptCostFileName += `${this.bucket}/${name},`
        })
        this.acceptModal.data.acceptCostFileName = acceptCostFileName.substring(0, acceptCostFileName.lastIndexOf(','))
      },
      day (time) {
        const day = (getNextMonth(time * 1000, 1) - new Date().getTime()) / (1000 * 60 * 60 * 24)
        return Math.round(day)
      },
      loadData () {
        this.$refs.table.loadData()
      },
      hasten (id) {
        this.$dialog.confirm({
          text: `确认向客户发送催交信息吗?`,
          title: '系统提示',
          width: 300,
          actions: {
            false: { color: 'grey', text: '取消' },
            true: {
              color: 'primary',
              text: '确认',
              handle: () => new Promise(resolve => {
                hasten(id, 1).then(response => {
                  const { status } = response
                  if (status === 200) {
                    this.loadData()
                    this.$dialog.notify.success('催交成功', { position: 'top-right', timeout: 4000 })
                  }
                  resolve(response)
                })
              })
            }
          }
        })
      }
    }
  }
</script>

<style lang="sass">
</style>
